import * as stylex from '@stylexjs/stylex';
import { FaSpotify } from 'react-icons/fa';
import { MdPerson } from 'react-icons/md';
import { LabeledSection } from '~pages/Profile/components/LabeledSection';
import { styles } from './styles';
import type { PublicSpotifyArtist } from '~pages/Profile/query';
export function TopArtists({
  artists
}: {
  artists: PublicSpotifyArtist[];
}) {
  if (artists.length === 0) return null;
  return <LabeledSection label="Top artists" icon={<FaSpotify size={18} {...stylex.props(styles.logo)} />}>
      <div {...stylex.props(styles.grid)}>
        {artists.map(artist => <div key={artist.id} {...stylex.props(styles.tile)}>
            <div {...stylex.props(styles.image)}>
              {artist.imageUrl ? <img {...stylex.props(styles.img)} src={artist.imageUrl} alt="" /> : <MdPerson size={28} {...stylex.props(styles.fallback)} />}
            </div>
            <span {...stylex.props(styles.name)}>{artist.name}</span>
          </div>)}
      </div>
    </LabeledSection>;
}